import { Box, Typography, Button, Link, Grid } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useState } from "react";
import gradient from "assets/images/background/gradientbg.jpeg";
import gradient2 from "assets/images/background/gradientbg2.jpg";
import ourservice1 from "assets/images/background/ourservice.png";
import ourservice2 from "assets/images/background/ourservice2.png";
import ourservice3 from "assets/images/background/ourservice3.png";

import EastIcon from "@mui/icons-material/East";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { BookAppointmentModel } from "components";

const OurFacility = () => {
  const [openModel, setOpenModel] = useState(false);

  const openPopup = () => setOpenModel(true);
  const closePopup = () => setOpenModel(false);

  return (
<>

 <Box
  p={{ md: 10, xs: 5 }}
  sx={{
    background: `url(${gradient2}) no-repeat`,
    backgroundSize: "100% 100%",
    minHeight: "31.25rem",
   
    alignItems: "center",     // vertically center
    
  }}
>

      <Box textAlign="center" mb={8}>
        <Typography variant="subHeader">
          WaveLight Plus InnovEyes Technology
        </Typography>
      </Box>
      <Grid container spacing={4} sx={{alignItems: "center", }}>
        
        <Grid
          item
          xs={12}
          md={6}
          flexDirection="column"
          justifyContent="center"
        >
          <Typography
            fontSize={"3.125rem"}
            fontWeight="bold"
            mb={2}
            textTransform="uppercase"
          >
            Sharper Vision 
          </Typography>
          <Typography fontSize={"2rem"} textTransform="uppercase" mb={4}>
            in Just 15 Seconds Per Eye
          </Typography>
          <Typography variant="h6" color="#777" lineHeight={2}>
            Step into the future of eye health with AI-guided vision correction that combines speed, precision, and comfort like never before. In just 15 seconds per eye, advanced laser technology reshapes your cornea with unmatched accuracy — completely bladeless and pain-free
          </Typography>
          <Box>
            <Link
              component={RouterLink}
              to="/department-internal/ophthalmology/wavelight-plus"
              sx={{ textDecoration: "none" }}
              color={"common.black"}
            >
              <Button color="primary" variant="text" sx={{ px: 0 }}>
                <Box
                  bgcolor={"primary.main"}
                  borderRadius={"0.5rem"}
                  color={"common.white"}
                  p={1}
                  width={"2.5rem"}
                  height={"2.5rem"}
                  display="flex"
                  alignItems={"center"}
                  justifyContent="center"
                  mr={1.5}
                >
                  <EastIcon fontSize="small" color="inherit" />
                </Box>
                Learn more
              </Button>
            </Link>
          </Box>
        </Grid>
        <Grid item xs={12} md={6} height="37.5rem">
          <img
            src={ourservice3}
            width="100%"
            height="100%"
            alt="service"
            style={{ objectFit: "contain" }}
          />
        </Grid>
      </Grid>

    </Box>
     
    <Box
      p={{ md: 10, xs: 5 }}
      sx={{
        background: `url(${gradient}) no-repeat`,
        backgroundSize: "100% 100%",
      }}
      minHeight="31.25rem"
    >
      
      <Box textAlign="center" mb={8}>
        <Typography variant="subHeader">
          Our Revolutionary Vision Care
        </Typography>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6} height="37.5rem">
          <img
            src={ourservice2}
            width="100%"
            height="100%"
            alt="service"
            style={{ objectFit: "contain" }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          flexDirection="column"
          justifyContent="center"
        >
          <Typography
            fontSize={"3.125rem"}
            fontWeight="bold"
            mb={2}
            textTransform="uppercase"
          >
            Specs removal Smile Pro
          </Typography>
          <Typography fontSize={"2rem"} textTransform="uppercase" mb={4}>
            Experience Life Without Glasses in 9 seconds
          </Typography>
          <Typography variant="h6" color="#777" lineHeight={2}>
            Seconds Discover the groundbreaking Specs Removal Smile Pro, a swift
            and painless procedure that can change your life in just 9 seconds.
            Say goodbye to glasses and enjoy the freedom of crystal-clear vision
            with this innovative treatment. Transform your daily life with the
            precision and ease of Smile Pro.
          </Typography>
          <Box>
            <Link
              component={RouterLink}
              to="/department-internal/ophthalmology/smileProSurgery"
              sx={{ textDecoration: "none" }}
              color={"common.black"}
            >
              <Button color="primary" variant="text" sx={{ px: 0 }}>
                <Box
                  bgcolor={"primary.main"}
                  borderRadius={"0.5rem"}
                  color={"common.white"}
                  p={1}
                  width={"2.5rem"}
                  height={"2.5rem"}
                  display="flex"
                  alignItems={"center"}
                  justifyContent="center"
                  mr={1.5}
                >
                  <EastIcon fontSize="small" color="inherit" />
                </Box>
                Learn more
              </Button>
            </Link>
            <Button
              color="primary"
              variant="text"
              sx={{ px: 0, ml: 2 }}
              onClick={openPopup}
            >
              <Box
                bgcolor={"primary.main"}
                borderRadius={"0.5rem"}
                color={"common.white"}
                p={1}
                width={"2.5rem"}
                height={"2.5rem"}
                display="flex"
                alignItems={"center"}
                justifyContent="center"
                mr={1.5}
              >
                <CalendarMonthIcon fontSize="small" color="inherit" />
              </Box>
              Book Appointment
            </Button>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={4} mt={4}>
        <Grid
          item
          xs={12}
          md={6}
          flexDirection="column"
          justifyContent="center"
        >
          <Typography
            fontSize={"3.125rem"}
            fontWeight="bold"
            mb={2}
            textTransform="uppercase"
          >
            Robotic Cataract Surgery
          </Typography>
          <Typography fontSize={"2rem"} textTransform="uppercase" mb={4}>
            Advanced Robotic Precision for Clearer Vision
          </Typography>
          <Typography variant="h6" color="#777" lineHeight={2}>
            Experience the future of cataract treatment with our Robotic
            Cataract Surgery. This cutting-edge procedure offers exceptional
            accuracy and safety, ensuring optimal lens replacement and faster
            recovery. Trust our expert surgeons to restore your vision with the
            most advanced technology available.
          </Typography>
          <Box>
            <Link
              component={RouterLink}
              to="/department-internal/ophthalmology/cataract"
              sx={{ textDecoration: "none" }}
              color={"common.black"}
            >
              <Button color="primary" variant="text" sx={{ px: 0 }}>
                <Box
                  bgcolor={"primary.main"}
                  borderRadius={"0.5rem"}
                  color={"common.white"}
                  p={1}
                  width={"2.5rem"}
                  height={"2.5rem"}
                  display="flex"
                  alignItems={"center"}
                  justifyContent="center"
                  mr={1.5}
                >
                  <EastIcon fontSize="small" color="inherit" />
                </Box>
                Learn more
              </Button>
            </Link>
            <Button
              color="primary"
              variant="text"
              sx={{ px: 0, ml: 2 }}
              onClick={openPopup}
            >
              <Box
                bgcolor={"primary.main"}
                borderRadius={"0.5rem"}
                color={"common.white"}
                p={1}
                width={"2.5rem"}
                height={"2.5rem"}
                display="flex"
                alignItems={"center"}
                justifyContent="center"
                mr={1.5}
              >
                <CalendarMonthIcon fontSize="small" color="inherit" />
              </Box>
              Book Appointment
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12} md={6} height="37.5rem">
          <img
            src={ourservice1}
            width="100%"
            height="100%"
            alt="service"
            style={{ objectFit: "contain" }}
          />
        </Grid>
      </Grid>
      {openModel && <BookAppointmentModel onClose={closePopup} />}
    </Box>
    </>
  );
};

export default OurFacility;
